import Dummy from "components/Dummy";
import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import { AuthContext } from "providers/AuthProvider";
import { useContext, useEffect, useState } from "react";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import MobileSignIn from "routes/account/signIn/MobileSignIn";
import qrcodeIcon from "resources/img/puffu/qrcodeIcon.png";
import mypageIcon from "resources/img/puffu/mypage.png";
import CustomIcon from "components/icons/CustomIcon";
import Center from "layouts/wrapper/Center";
import BackButton from "components/buttons/BackButton";
import logo from "resources/img/puffu/puffuIcon.png";
import MobileNumberSignIn from "routes/account/signIn/MobileNumberSignIn";
import RenewMobileHeader from "routes/mobile/home/layout/RenewMobileHeader";

function MobileLayout(props) {
    const { userId } = useContext(AuthContext);
    const { id } = useParams();
    const location = useLocation();
    const [selectedMenu, setSelectedMenu] = useState("scan");
    const navigate = useNavigate();
    const [headerHeight, setHeaderHeight] = useState("50px");



    useEffect(() => {

        
        const path = location.pathname.split("/").pop();
        
        if (path) {
            setSelectedMenu(path === "mobile" ? "mypage" : path);
            if (path === "withdrawal") {
                setSelectedMenu("mypage");
            } else if (path === "receipt") {
                setSelectedMenu("mypage");
            } else if (location.pathname.includes("review")) {
                setSelectedMenu("mypage");
            }else if (location.pathname.includes("receipt")) {
                setSelectedMenu("mypage");
            }
        }
    }, [location.pathname, id]);

    const handleMenuClick = (menu) => {
        setSelectedMenu(menu);
        navigate(menu === "mypage" ? `/ws/${id}/mobile` : `/ws/${id}/mobile/${menu}`);
    };

    const FooterMenu = ({ icon, label, menu }) => {
        const isSelected = selectedMenu === menu;
        const iconStyle = {
            width: "20px",
            opacity: isSelected ? 1 : 0.6,
            filter: isSelected ? "none" : "grayscale(100%)"
        };
        const textStyle = isSelected ? "black" : "rgba(0, 0, 0, 0.4)";
        return (
            <FlexChild>
                <div
                    style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}
                    onClick={() => handleMenuClick(menu)}
                >
                    <img src={icon} style={iconStyle} alt={label} />
                    <Dummy height={"5px"} />
                    <P color={textStyle}>{label}</P>
                </div>
            </FlexChild>
        );
    };

    const onSettingBtnClick = () => {
        navigate(`/ws/${id}/mobile/setting`);
    };

    return (
        <div>
            <RenewMobileHeader />
            {userId ? (
                <div>
                    {selectedMenu === "mypage" && (
                        <div
                            style={{
                                position: "absolute",
                                top: 0,
                                zIndex: 99,
                                width: "100%",
                                height: headerHeight,
                                backgroundColor: "#F0F1F3"
                            }}
                        >
                            <div style={{ width: "90%", margin: "0 auto", height: headerHeight }}>
                                <HorizontalFlex>
                                    <FlexChild>
                                        {headerHeight === "50px" ? (
                                            <BackButton alignItems={"flex-start"} />
                                        ) : null}
                                    </FlexChild>
                                    <FlexChild>
                                        <Center alignItems={"flex-end"}>
                                            <div onClick={onSettingBtnClick}>
                                                <CustomIcon name={"setting"} width={headerHeight === "50px" ? "25px" : 0} />
                                            </div>
                                        </Center>
                                    </FlexChild>
                                </HorizontalFlex>
                            </div>
                        </div>
                    )}
                    <Outlet />
                    <div
                        style={{
                            position: "fixed",
                            bottom: 0,
                            zIndex: 99,
                            width: "100%",
                            height: "10vh",
                            backgroundColor: "white",
                            boxShadow: "0px -1px 11.1px -5px rgba(0, 0, 0, 0.25)",
                            borderRadius: "10px 10px 0px 0px"
                        }}
                    >
                        <HorizontalFlex>
                            <FooterMenu icon={qrcodeIcon} label="결제" menu="scan" />
                            <FooterMenu icon={logo} label="매장찾기" menu="storeList" />
                            <FooterMenu icon={mypageIcon} label="내 정보" menu="mypage" />
                        </HorizontalFlex>
                    </div>
                </div>
            ) : (
                <MobileNumberSignIn storeCode={id} />
            )}
        </div>
    );
}

export default MobileLayout;